export var SECTION_ITEMS = ['Menu', 'Hours of Operation', 'Colors', 'Photos', 'Reviews', 'Fonts', 'Address', 'Business Description', 'Other'];